import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal, TbSwitchHorizontal } from "react-icons/tb";
import { ValutField, ValutSelect } from "../../../Components/Atoms/ValutInput";
import { ModernFilterBar } from "../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_PIX_STATEMENT_FILTERS,
  buildPixStatementFilterTags,
  exportPixStatementCsv,
  getPixProductOptions,
  hasActivePixStatementFilters,
  isPixChipFilterActive,
  removePixStatementFilterTag,
} from "./pixStatementFilters";

const PixMoreFiltersForm = ({ draft, onChange, subAccounts = [] }) => (
  <div className="extract-more-filters-form">
    <MoreFiltersDateSection draft={draft} onChange={onChange} />
    <MoreFiltersAmountSection draft={draft} onChange={onChange} idPrefix="pix-more" />
    <MoreFiltersCheckboxSection
      label={intl.get("extract.filterType")}
      options={getPixProductOptions()}
      selectedValues={draft.productId ? [draft.productId] : []}
      onChange={(values) => onChange({ ...draft, productId: values[0] || "" })}
      idPrefix="pix-more-type"
    />
    {Array.isArray(subAccounts) && subAccounts.length >= 1 && (
      <section className="extract-more-filters-form__section">
        <ValutField label={intl.get("extract.subAccount")} htmlFor="pix-more-sub-account">
          <ValutSelect
            id="pix-more-sub-account"
            value={draft.subAccountId}
            onChange={(event) => onChange({ ...draft, subAccountId: event.target.value })}
          >
            <option value="">{intl.get("common.all")}</option>
            {subAccounts.map((sa) => (
              <option key={sa.subAccountId} value={sa.subAccountId}>
                {sa.name}
              </option>
            ))}
          </ValutSelect>
        </ValutField>
      </section>
    )}
  </div>
);

export const PixFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
  subAccounts = [],
}) => {
  const typeOptions = getPixProductOptions();

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isPixChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isPixChipFilterActive(filters, "amount"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("extract.filterType"),
      active: isPixChipFilterActive(filters, "type"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return <AmountFilterPanel draft={draft} onChange={onChange} idPrefix="pix-filter" />;
      case "type":
        return (
          <CheckboxListFilterPanel
            options={typeOptions}
            selectedValues={draft.productId ? [draft.productId] : []}
            onChange={(values) => onChange({ ...draft, productId: values[0] || "" })}
            idPrefix="pix-type"
            singleSelect
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_PIX_STATEMENT_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isPixChipFilterActive(filters, "subAccount")}
      buildFilterTags={(nextFilters) => buildPixStatementFilterTags(nextFilters, subAccounts)}
      hasActiveFilters={hasActivePixStatementFilters}
      removeFilterTag={removePixStatementFilterTag}
      onExport={exportPixStatementCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <PixMoreFiltersForm draft={draft} onChange={onChange} subAccounts={subAccounts} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        type: intl.get("extract.filterType"),
      }}
    />
  );
};
